import { Material_Read_Typeahead } from '@treadinc/horizon-api-spec';

import { MaterialTypeahead } from './models';

export const toMaterialTypeaheadOption = (material: Material_Read_Typeahead) => {
  const parsed = MaterialTypeahead.parse(material);

  return {
    label: parsed.externalId ? `${parsed.externalId} - ${parsed.name}` : parsed.name,
    value: parsed.id,
  };
};
